import Vue from "vue";
import VueRouter from "vue-router";
import { App } from "@capacitor/app";
import store from "@/store";

import Login from "@/views/onboarding/Login.vue";
import Admin from "@/views/admin/Admin.vue";
import Select from "@/views/test/Select.vue";
import Prestart from "@/views/test/Prestart.vue";
import Testhall from "@/views/test/Testhall.vue";
import Submitted from "@/views/test/Submitted.vue";
import Landing from "@/views/onboarding/Landing.vue";
import Dashboard from "@/views/dashboard/Dashboard.vue";
import UploadQuestion from "@/views/admin/UploadQuestion.vue";
// import AddInstitution from "@/views/admin/AddInstitution.vue";
import AdminHome from "@/views/admin/AdminHome.vue";
import CeoDashboard from "@/views/ceodashboard/CeoDashboard.vue";
import EditQuestion from "@/views/admin/EditQuestion.vue";
// import ListQuestion from "@/views/admin/ListQuestion.vue";
import DashHome from "@/views/dashboard/DashHome.vue";
import LeaderBoard from "@/views/dashboard/LeaderBoard";
import ScheduleTest from "@/views/dashboard/ScheduleTest";
import MoreResults from "@/views/dashboard/MoreResults";
import ResultBreakdown from "@/views/dashboard/ResultBreakdown";
import UpdateProfile from "@/views/dashboard/UpdateProfile";
// import ListInstitution from "@/views/admin/ListInstitution";
// import EditInstitution from "@/views/admin/EditInstitution";
import NotFound from "@/views/NotFound";
import NetworkIssue from "@/views/NetworkIssue";
// import IconFull from "@/views/onboarding/IconFull";
import CeoDashhome from "@/views/ceodashboard/CeoDashhome";
import AllCounts from "@/views/ceodashboard/AllCounts";
import Emailer from "@/views/ceodashboard/Emailer";
import HR from "@/views/ceodashboard/HR";
import StockingStat from "@/views/admin/StockingStat";
import MarkQuestion from "@/views/admin/MarkQuestion";
import MqSubject from "@/views/admin/MqSubject";
import MqMark from "@/views/admin/MqMark";
import QuestionsFor from "@/views/admin/QuestionsFor.vue";
import EditQuestionSup from "@/views/admin/EditQuestionSup";
import Signup from "@/views/onboarding/Signup";
import Forgot from "@/views/onboarding/Forgot";
import ConfirmMail from "@/views/onboarding/ConfirmMail";
import Upgrade from "@/views/onboarding/Upgrade";
import VerifyP from "@/views/onboarding/VerifyP";
import addCategories from "../views/admin/addCategories";
// import editCategories from "../views/admin/editCategories";
import addTopics from "../views/admin/addTopics";
import editTopics from "../views/admin/editTopics";
import addBlogpost from "../views/admin/addBlogpost";
import editBlogpost from "../views/admin/editBlogpost";
import listBlogpost from "../views/admin/listBlogpost";
import listCategories from "../views/admin/listCategories";
import listTopics from "../views/admin/listTopics";
import topicsFor from "../views/admin/topicsFor";
import listBlogdrafts from "../views/admin/listBlogdrafts";
import editBlogdrafts from "../views/admin/editBlogdrafts";
import resultHome from "../views/dashboard/resultHome";
import createTestspaces from "../views/admin/createTestspaces";
import editTestspaces from "../views/admin/editTestspaces";
import listTestspaces from "../views/admin/listTestspaces";
import viewTestspace from "../views/admin/viewTestspace";
import createCompetition from "../views/admin/createCompetition";
import editCompetition from "../views/admin/editCompetition";
import listCompetition from "../views/admin/listCompetition";
import viewCompetition from "../views/admin/viewCompetition";
import CreateAdmin from "../views/admin/CreateAdmin";
import configureOrganization from "../views/admin/configureOrganization";
import companyMetrics from "../views/admin/companyMetrics";
// import listOrgspaces from "../views/dashboard/listOrgspaces";
import listOrgtestspaces from "../views/dashboard/listOrgtestspaces";
import viewOrgtestspaces from "../views/dashboard/viewOrgtestspaces";
import spaceHome from "../views/dashboard/spaceHome";
import userMetrics from "../views/dashboard/userMetrics";
import joinTestspace from "../views/dashboard/joinTestspace";
import sendMails from "../views/admin/sendMails";
import Partnerships from "../views/admin/Partnerships";
import Coupons from "../views/admin/createCoupons";
import viewCoupons from "../views/admin/viewCoupons.vue";
import editPartnership from "../views/admin/editPartnership";
import subscriptionPlan from "../views/dashboard/subscriptionPlan";
import editCoupon from "../views/admin/editCoupon";
import ambassadorUser from "../views/dashboard/ambassadorUser";
import userEarnings from "../views/dashboard/userEarnings";
import ambassadorAdmin from "../views/admin/ambassadorAdmin";
import Payouts from "../views/admin/Payouts";
import addContents from "../views/admin/addContents";
import editContent from "../views/admin/editContent";
import listContents from "../views/admin/listContents";
import DashboardOrg from "../views/organization/DashboardOrg";
import DashhomeOrg from "../views/organization/DashhomeOrg";
import AddTestgroups from "../views/organization/Testgroups/AddTestgroups";
import ListTestgroups from "../views/organization/Testgroups/ListTestgroups";
import CampaignsView from "../views/admin/CampaignsView";
import setDiscount from "../views/admin/SetDiscount.vue";
import viewNotification from "../views/dashboard/viewNotification.vue";
import listNotifications from "../views/dashboard/listNotifications.vue";
import addNotifications from "../views/admin/addNotifications.vue";
import editNotifications from "../views/admin/editNotifications.vue";
import listAdminNotifications from "../views/admin/listNotifications.vue";
import addAmbassadors from "../views/admin/addAmbassadors.vue";
import editAmbassadors from "../views/admin/editAmbassadors.vue";
import UploadQuestionOrg from "@/views/organization/questions/UploadQuestion.vue";
import ListQuestionOrg from "@/views/organization/questions/ListQuestion.vue";
import ProfileViewOrg from "@/views/organization/settings/profile/index.vue";
import SubscriptionsViewOrg from "@/views/organization/Subscriptions/index.vue";
import candidatesAndGroups from "@/views/organization/candidatesAndGroups/groups/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "",
    name: "landing",
    component: Landing
    // redirect: { name: "login" }
  },
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/:orgShortname/portal/login",
    name: "orgportallogin",
    component: () => import("../views/organization/onboarding/Login.vue")
  },
  {
    path: "/:orgShortname/portal/:candidate/testspaces",
    name: "jointestspacecandidate",
    component: () =>
      import("../views/organization/onboarding/CandidateTestspaces.vue")
  },
  {
    path: "/signup",
    name: "signup",
    component: Signup
  },
  {
    path: "/forgot",
    name: "forgot",
    component: Forgot
  },
  {
    path: "/confirmmail",
    name: "confirmmail",
    component: ConfirmMail
  },
  {
    path: "/upgrade",
    name: "upgrade",
    component: Upgrade
  },
  {
    path: "/testspace/:trackcode",
    name: "jointestspace",
    component: joinTestspace
  },
  {
    path: "/verify",
    name: "verify",
    component: VerifyP
  },
  {
    path: "/orgadmin",
    name: "orgdashboard",
    component: DashboardOrg,
    props: true,
    children: [
      {
        path: "",
        name: "orgdashboardhome",
        component: DashhomeOrg
      },
      {
        path: "add/testgroup/:trackid?",
        name: "addtestgroup",
        component: AddTestgroups
      },
      {
        path: "list/testgroup",
        name: "listtestgroups",
        component: ListTestgroups
      },
      {
        path: "view/testgroups/:trackid",
        name: "viewtestgrouporg",
        component: () =>
          import("../views/organization/Testgroups/ViewTestgroup.vue")
      },
      {
        path: "questions/upload/:trackid?",
        name: "uploadquestionsorg",
        component: UploadQuestionOrg
      },
      {
        path: "questions/list",
        name: "listquestionsorg",
        component: ListQuestionOrg
      },
      {
        path: "list/for/questions/:identity",
        name: "questionsfororg",
        component: QuestionsFor
      },
      {
        path: "createtestspaces/:trackid?",
        name: "createtestspacesorg",
        component: createTestspaces
      },
      {
        path: "list/testspaces",
        name: "listtestspacesorg",
        component: listTestspaces
      },
      {
        path: "edit/testspaces/:trackid",
        name: "edittestspaces",
        component: editTestspaces
      },
      {
        path: "view/testspaces/:trackid",
        name: "viewtestspaceorg",
        component: viewTestspace
      },
      {
        path: "view/testspace/realtime/:trackid",
        name: "viewtestspacerealtimeorg",
        component: () =>
          import("../views/organization/Testspaces/RealtimeStats.vue")
      },
      {
        path: "profile/",
        name: "ProfileViewOrg",
        component: ProfileViewOrg
      },
      {
        path: "settings/",
        name: "SettingsOrg",
        component: () =>
          import("../views/organization/settings/configurations/index.vue")
      },
      {
        path: "subscriptions/",
        name: "SubscriptionsViewOrg",
        component: SubscriptionsViewOrg
      },
      {
        path: "groups/",
        name: "candiatesandgroupsorg",
        component: candidatesAndGroups
      },
      {
        path: "groups/add",
        name: "addnewgrouporg",
        component: () =>
          import(
            "../views/organization/candidatesAndGroups/groups/AddNewGroup.vue"
          )
      },
      {
        path: "groups/view/:trackid",
        name: "viewgrouporg",
        component: () =>
          import(
            "../views/organization/candidatesAndGroups/groups/viewGroup.vue"
          )
      },
      {
        path: "groups/edit/:trackid",
        name: "editgrouporg",
        component: () =>
          import(
            "../views/organization/candidatesAndGroups/groups/AddNewGroup.vue"
          )
      },
      {
        path: "candidates/add",
        name: "addnewcandidateorg",
        component: () =>
          import(
            "../views/organization/candidatesAndGroups/candidates/AddCandidates.vue"
          )
      },
      {
        path: "candidates/import",
        name: "importnewcandidatesorg",
        component: () =>
          import(
            "../views/organization/candidatesAndGroups/candidates/importCandidates.vue"
          )
      },
      {
        path: "candidates/edit/:trackid",
        name: "editcandidateorg",
        component: () =>
          import(
            "../views/organization/candidatesAndGroups/candidates/AddCandidates.vue"
          )
      }
    ]
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    props: true,
    children: [
      {
        path: "",
        name: "adminhome",
        component: AdminHome
      },
      {
        path: "add/question/:trackid?",
        name: "uploadquestion",
        component: UploadQuestion
      },
      {
        path: "add/institution/:trackid?",
        name: "addinstitution",
        component: AddTestgroups
      },
      {
        path: "view/testgroups/:trackid",
        name: "viewtestgroup",
        component: () =>
          import("../views/organization/Testgroups/ViewTestgroup.vue")
      },
      {
        path: "list/questions",
        name: "listquestion",
        component: ListQuestionOrg
      },
      {
        path: "edit/question/:trackid",
        name: "editquestion",
        component: EditQuestion
      },
      {
        path: "list/institutions",
        name: "listinstitution",
        component: ListTestgroups
      },
      {
        path: "edit/institution/:trackid",
        name: "editinstitution",
        component: AddTestgroups
      },
      {
        path: "stockingstatistics",
        name: "stockingstat",
        component: StockingStat
      },
      {
        path: "markquestion",
        name: "markquestion",
        component: MarkQuestion
      },
      {
        path: "markquestion/:insti/:trackid",
        name: "mqinsti",
        component: MqSubject
      },
      {
        path: "markquestion/:insti/:subject",
        name: "mqmark",
        component: MqMark
      },
      {
        path: "list/for/questions/:identity",
        name: "questionsfor",
        component: QuestionsFor
      },
      {
        path: "editsuper/question/:trackid",
        name: "editquestionsuper",
        component: EditQuestionSup
      },
      {
        path: "add/Categories",
        name: "addCategories",
        component: addCategories
      },
      {
        path: "list/category",
        name: "listCategories",
        component: listCategories
      },
      {
        path: "edit/category/:trackid",
        name: "editcategory",
        component: addCategories
      },
      {
        path: "add/topics",
        name: "addtopics",
        component: addTopics
      },
      {
        path: "list/topic",
        name: "listtopics",
        component: listTopics
      },
      {
        path: "list/for/topics/:identity",
        name: "topicsfor",
        component: topicsFor
      },
      {
        path: "edit/topic/:trackid",
        name: "edittopics",
        component: editTopics
      },
      {
        path: "add/blogpost",
        name: "addblogpost",
        component: addBlogpost
      },
      {
        path: "list/blogpost",
        name: "listblogposts",
        component: listBlogpost
      },
      {
        path: "edit/blogpost/:trackid",
        name: "editblogpost",
        component: editBlogpost
      },
      {
        path: "list/blogdrafts",
        name: "listblogdrafts",
        component: listBlogdrafts
      },
      {
        path: "edit/blogdrafts/:trackid",
        name: "editblogdraft",
        component: editBlogdrafts
      },
      {
        path: "createtestspaces/:trackid?",
        name: "createtestspaces",
        component: createTestspaces
      },
      {
        path: "list/testspaces",
        name: "listtestspaces",
        component: listTestspaces
      },
      {
        path: "edit/testspaces/:trackid",
        name: "edittestspaces",
        component: editTestspaces
      },
      {
        path: "view/testspaces/:trackid",
        name: "viewtestspace",
        component: viewTestspace
      },
      {
        path: "createcompetition/",
        name: "createcompetition",
        component: createCompetition
      },
      {
        path: "list/competition",
        name: "listcompetition",
        component: listCompetition
      },
      {
        path: "edit/competition/:trackid",
        name: "editcompetition",
        component: editCompetition
      },
      {
        path: "view/competition/:trackid",
        name: "viewcompetition",
        component: viewCompetition
      },
      {
        path: "createadmin/",
        name: "createadmins",
        component: CreateAdmin
      },
      {
        path: "configureorganization/",
        name: "configureorganization",
        component: configureOrganization
      },
      {
        path: "companymetrics/",
        name: "companymetrics",
        component: companyMetrics
      },
      {
        path: "sendmails/",
        name: "sendmails",
        component: sendMails
      },
      {
        path: "partnerships/all",
        name: "allpartnerships",
        component: () => import("../views/admin/allPartnerships.vue")
      },
      {
        path: "partnerships/create",
        name: "createpartnerships",
        component: Partnerships
      },
      {
        path: "coupons/",
        name: "coupons",
        component: Coupons
      },
      {
        path: "coupons/view",
        name: "viewcoupons",
        component: viewCoupons
      },
      {
        path: "edit/partnership/:trackid",
        name: "editpartnership",
        component: editPartnership
      },
      {
        path: "edit/coupon/:trackid",
        name: "editcoupon",
        component: editCoupon
      },
      {
        path: "ambassadors/stats",
        name: "ambassadorstats",
        component: ambassadorAdmin
      },
      {
        path: "ambassadors/payouts",
        name: "payouts",
        component: Payouts
      },
      {
        path: "add/contents",
        name: "addcontent",
        component: addContents
      },
      {
        path: "edit/content/:trackid",
        name: "editcontent",
        component: editContent
      },
      {
        path: "list/contents",
        name: "listcontents",
        component: listContents
      },
      {
        path: "add/notifications",
        name: "addnotifications",
        component: addNotifications
      },
      {
        path: "edit/notifications/:trackid",
        name: "editnotifications",
        component: editNotifications
      },
      {
        path: "list/notifications",
        name: "listnotifications",
        component: listAdminNotifications
      },
      {
        path: "add/ambassadors",
        name: "addambassadors",
        component: addAmbassadors
      },
      {
        path: "edit/ambassadors/:email",
        name: "editambassadors",
        component: editAmbassadors
      },
      {
        path: "view/campaigns",
        name: "campaigns",
        component: CampaignsView
      },
      {
        path: "discount/",
        name: "discount",
        component: setDiscount
      },
      {
        path: "users/all",
        name: "allusers",
        component: () => import("../views/admin/AllUsers.vue")
      }
    ]
  },
  {
    path: "/ceodashboard",
    name: "ceodashboard",
    component: CeoDashboard,
    children: [
      {
        path: "/ceo",
        name: "ceohome",
        component: CeoDashhome
      },
      {
        path: "allcounts",
        name: "allcounts",
        component: AllCounts
      },
      {
        path: "hr",
        name: "hr",
        component: HR
      },
      {
        path: "emailer",
        name: "emailer",
        component: Emailer
      }
    ]
  },
  {
    path: "/select",
    name: "select",
    component: Select
  },
  {
    path: "/confirmexam",
    name: "confirm",
    component: Prestart
  },
  {
    path: "/testhall/:category/:institution/:trackid",
    name: "testhall",
    component: Testhall,
    props: true
  },
  {
    path: "/testcompleted",
    name: "submitted",
    component: Submitted
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
    children: [
      {
        path: "",
        name: "dashhome",
        component: DashHome
      },
      {
        path: "leaderboard",
        name: "leaderboard",
        component: LeaderBoard
      },
      {
        path: "scheduler",
        name: "scheduler",
        component: ScheduleTest
      },
      {
        path: "metrics",
        name: "performancecurve",
        component: userMetrics
      },
      {
        path: "view-notification/:id",
        name: "view-notification",
        component: viewNotification
      },
      {
        path: "list-notifications",
        name: "list-notifications",
        component: listNotifications
      },
      {
        path: "results",
        name: "results",
        component: resultHome,
        children: [
          {
            path: "allresults",
            name: "moreresults",
            component: MoreResults
          },
          {
            path: "breakdown/:trackid",
            name: "breakdown",
            component: ResultBreakdown,
            props: true
          }
        ]
      },
      {
        path: "referrals",
        name: "referrals",
        component: () => import("../views/dashboard/ReferralsHome.vue")
      },

      {
        path: "updateprofile",
        name: "updateprofile",
        component: UpdateProfile
      },
      {
        path: "competitions",
        name: "competitions",
        component: listOrgtestspaces
      },
      {
        path: "competitions",
        name: "competitions",
        component: listOrgtestspaces
      },
      {
        path: "testspaces",
        name: "testspaces",
        component: listOrgtestspaces
      },
      {
        path: "spaces",
        name: "spaces",
        component: spaceHome,
        children: [
          {
            path: "",
            name: "listorgspaces",
            component: listOrgtestspaces
          },
          {
            path: "list/:orgspace/testspaces",
            name: "listorgtestspaces",
            component: listOrgtestspaces
          },
          {
            path: "view/:orgspace/testspace/:trackid",
            name: "vieworgtestspaces",
            component: viewOrgtestspaces
          }
        ]
      },
      {
        path: "subscription",
        name: "subscription",
        component: subscriptionPlan
      },
      {
        path: "ambassador/statistics",
        name: "ambstats",
        component: ambassadorUser
      },
      {
        path: "ambassador/earnings",
        name: "ambearnings",
        component: userEarnings
      },
      {
        path: "studyroom/:id?",
        name: "studyroom",
        component: () =>
          import("../views/dashboard/StudyRoom.vue")
      }
      
    ]
  },
  {
    path: "/404",
    name: "404",
    component: NotFound
  },
  {
    path: "/network",
    name: "network",
    component: NetworkIssue
  },
  {
    path: "*",
    redirect: { name: "404" }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
  }
});

router.afterEach(to => {
  store.dispatch("loginmaster/saveLastRoute", to.fullPath);
});

App.addListener("appUrlOpen", function(event) {
  // Example url: https://beerswift.app/tabs/tabs2
  // slug = /tabs/tabs2
  const slug = event.url.split(".com").pop();
  // const query = event.url.split("?").pop();

  // We only push to the route if there is a slug present
  if (slug) {
    router.push(`${slug}`);
  }
});

export default router;
